
import { Header } from "@/components/layout/Header";
import { SchoolHeader } from "@/components/layout/SchoolHeader";
import { DailyVisitsList } from "@/components/nurse/DailyVisitsList";
import { StaffVisitsList } from "@/components/nurse/StaffVisitsList";

const Dispensary = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto p-6 pt-[160px] space-y-6">
        <SchoolHeader />
        
        <DailyVisitsList />
        
        <StaffVisitsList />
      </main>
    </div>
  );
};

export default Dispensary;
